import { Info } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

interface FieldTooltipProps {
  text: string;
}

export const FieldTooltip = ({ text }: FieldTooltipProps) => (
  <TooltipProvider>
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="inline-flex items-center cursor-default text-[#555] hover:text-[#888] transition-colors">
          <Info size={13} />
        </span>
      </TooltipTrigger>
      <TooltipContent
        side="right"
        className="max-w-xs bg-[#2A2A2A] border-[#444] text-[#CCC] text-xs leading-relaxed"
      >
        {text}
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);
